import { Link } from 'react-router-dom';

import { Group, Menu, rem, Text } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import {
  IconKey,
  IconLogout,
  IconSettings,
  IconUserCircle,
} from '@tabler/icons-react';

import useAuth from '@hooks/useAuth';

import EditUserPasswordForm from '@components/EditUserPasswordForm';

import logo from '@assets/images/logo.png';

import classes from './Header.module.css';

export default function Header() {
  const { user, logout } = useAuth();

  const handleEditPasswordClick = () => {
    openModal({
      modalId: 'editUserPassword',
      title: 'Modifica password',
      children: (
        <EditUserPasswordForm onSubmit={() => closeModal('editUserPassword')} />
      ),
    });
  };

  return (
    <header className={classes.header}>
      <Group justify="space-between">
        <a href="https://www.prodottigianni.com" target="_blank">
          <img src={logo} alt="Prodotti Gianni" style={{ width: rem(200) }} />
        </a>
        <Group>
          <Menu withArrow>
            <Menu.Target>
              <IconUserCircle size="2rem" />
            </Menu.Target>
            <Menu.Dropdown>
              {user!.role !== 'admin' && (
                <Menu.Item component={Link} to="/account">
                  <Group>
                    <IconSettings size="1.5rem" />
                    <Text c="black" size="sm">
                      Account
                    </Text>
                  </Group>
                </Menu.Item>
              )}
              <Menu.Item onClick={handleEditPasswordClick}>
                <Group>
                  <IconKey size="1.5rem" />
                  <Text size="sm">Modifica password</Text>
                </Group>
              </Menu.Item>
              <Menu.Item onClick={logout} c="red">
                <Group>
                  <IconLogout size="1.5rem" />
                  <Text size="sm">Logout</Text>
                </Group>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group>
    </header>
  );
}
